import { createEnrichedDataHook } from '@client/hooks/useBaseEnrichedData';
import { MultichoixBulkInitializeService } from '../services/multichoixBulkInitializeService';
import {
  TREATMENT_FIELD_TO_API,
  TREATMENT_API_TO_ENRICHED,
  TREATMENT_FIELD_TO_ENRICHED,
  TREATMENT_INITIAL_ENRICHED,
} from '@client/config/filterFieldMappings';

/**
 * Enriched data hook for Treatment Search page
 * Reuses the existing multichoix bulk-initialize endpoint for cold start support
 */
export const useTreatmentSearchEnrichedData = createEnrichedDataHook({
  fieldToApiMapping: TREATMENT_FIELD_TO_API,
  apiToEnrichedMapping: TREATMENT_API_TO_ENRICHED,
  fieldToEnrichedMapping: TREATMENT_FIELD_TO_ENRICHED,
  bulkInitialize: (ids) => MultichoixBulkInitializeService.bulkInitialize(ids),
  initialEnrichedData: TREATMENT_INITIAL_ENRICHED,
  hookName: 'useTreatmentSearchEnrichedData',
});

export default useTreatmentSearchEnrichedData;
